export function ChoiceOptionIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10 7.5L19 15.5L10 23.5" stroke="#858DBD" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
